import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';

import { AppProvider } from 'AppProvider';
import * as ROUTES from 'constants/paths';
import { BaseLayout } from 'layouts/BaseLayout/BaseLayout';
import { NoToolsLayout } from 'layouts/NoToolsLayout/NoToolsLayout';
import { UserAccountLayout } from 'layouts/UserAccountLayout/UserAccountLayout';

import { AccountPaymentInfoPage } from 'pages/AccountPaymentInfoPage/AccountPaymentInfoPage';
import { AccountSettingsPage } from 'pages/AccountSettingsPage/AccountSettingsPage';
import { AccountSubscriptionsInfoPage } from 'pages/AccountSubscriptionsInfoPage/AccountSubscriptionsInfoPage';
import { BusinessToolPage } from 'pages/BusinessToolPage/BusinessToolPage';
import { ErrorPage } from 'pages/ErrorPage/ErrorPage';
import { LoginPage } from 'pages/LoginPage';
import { OnePageSharedPage } from 'pages/OnePageSharedPage/OnePageSharedPage';
import { OnlyPayedSubscriptionsPlansPage } from 'pages/OnlyPayedSubscriptionsPlansPage/OnlyPayedSubscriptionsPlansPage';
import { PDFViewPage } from 'pages/PDFViewPage/PDFViewPage';
import { SubscriptionsPlansPage } from 'pages/SubscriptionsPlansPage/SubscriptionsPlansPage';
import { SuccessPaymentPage } from 'pages/SuccessPaymentPage';
// TODO: delete if client is agreed to pdf version
// import { TermsAndConditionsPlaceholderPage } from 'pages/TermsAndConditionsPlaceholderPage/TermsAndConditionsPlaceholderPage';
import { Workspace } from 'pages/Workspace/Workspace';

import { OnePagePreviewContainer } from 'components/OnePageTemplates';
import { ProtectedRoute } from 'components/ProtectedRoute/ProtectedRoute';
import { UnauthorizedRoute } from 'components/UnauthorizedRoute';

const router = createBrowserRouter([
  {
    element: <AppProvider />,
    children: [
      {
        element: <BaseLayout />,
        children: [
          { path: ROUTES.SUBSCRIPTION_PLAN, element: <SubscriptionsPlansPage /> },
          { path: ROUTES.SUBSCRIPTION_PLAN_2, element: <OnlyPayedSubscriptionsPlansPage /> },
          // TODO: delete if client is agreed to pdf version
          // { path: ROUTES.TERMS_AND_CONDITIONS, element: <TermsAndConditionsPlaceholderPage /> },
          {
            element: <UnauthorizedRoute />,
            children: [
              { path: ROUTES.HOME, element: <BusinessToolPage /> },
              { element: <NoToolsLayout />, children: [{ path: ROUTES.LOGIN, element: <LoginPage /> }] },
            ],
          },
          {
            element: <ProtectedRoute />,
            children: [
              { path: ROUTES.WORKSPACE, element: <Workspace /> },
              {
                element: <UserAccountLayout />,
                children: [
                  { path: ROUTES.ACCOUNT_SETTINGS, element: <AccountSettingsPage /> },
                  { path: ROUTES.ACCOUNT_SUBSCRIPTIONS, element: <AccountSubscriptionsInfoPage /> },
                  { path: ROUTES.ACCOUNT_PAYMENT_INFO, element: <AccountPaymentInfoPage /> },
                ],
              },
              {
                element: <NoToolsLayout />,
                children: [{ path: ROUTES.ONE_PAGE_PROTECTED, element: <OnePagePreviewContainer /> }],
              },
            ],
          },
          {
            element: <Outlet />,
            children: [{ path: ROUTES.BUSINESS_TOOL, element: <BusinessToolPage /> }],
          },
          { path: ROUTES.ERROR, element: <ErrorPage /> },
          { path: '*', element: <Navigate to="/error/404" replace /> },
        ],
      },
      { path: ROUTES.ONE_PAGE_VIEW, element: <OnePageSharedPage /> },
      { path: ROUTES.VIEW_PDF, element: <PDFViewPage /> },
      { path: ROUTES.SUCCESS_PAYMENT, element: <SuccessPaymentPage /> },
    ],
  },
]);

export default router;
